/**
 * Storage type for the application
 */
enum StorageType {
  None = 0,

  /**
   * Persistent storage shared to a particular origin.
   */
  Local,

  /**
   * Ephemeral storage cleared when tabs or window close.
   */
  Session,
}

export default StorageType;
